export const THUMBNAIL_CONFIG = {
  FIXED_HEIGHT: 185,
  SCALE: 0.15,
  OVERSCAN: 5,
} as const;

export const ARIA_LABELS = {
  selectPage: (pageNum: number) => `Select page ${pageNum}`,
  pageStatus: (pageNum: number, isDeleted: boolean, disabled: boolean) =>
    `Page ${pageNum}${isDeleted ? " (deleting)" : ""}${disabled ? " (disabled)" : ""}`,
  cannotSelectDeleted: "Cannot select deleted page",
  cannotSelectDisabled: "Cannot select page during operation",
} as const;
